import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {NoteRepository} from '../../repositories/base/note.repository';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {PostPayloadInterface} from '../../models/post-payload.interface';
import {NotificationService} from '../../services/common/notification.service';
import {Constants} from "../../utils/constants";

@Component({
    selector: 'app-notes',
    templateUrl: './notes.component.html',
    styleUrls: ['./notes.component.scss']
})
export class NotesComponent implements OnInit, OnChanges {

    @Input() notes: any[];
    @Input() extraNote: any;
    @Input() connectEntity: string;
    @Input() connectEntityId: number;
    @Output() saveCallback: EventEmitter<any> = new EventEmitter<any>();
    public focusTouched;
    public messageForm: FormGroup;
    public type = false;
    public answerNote = null;
    answerMode: boolean = false;
    noteTypes: string[];
    selectedNoteType: string;

    constructor(private noteRepository: NoteRepository, public formBuilder: FormBuilder, private notificationService: NotificationService) {
    }

    ngOnChanges(changes: SimpleChanges): void {

        if (this.notes) {
            this.notes.sort((a, b) => b.createdAt.localeCompare(a.createdAt));
        }
    }

    toDate(dateString) {
        return new Date(dateString);
    }

    ngOnInit() {
        this.noteTypes = Object.values(Constants.NOTE_TYPE);
        this.selectedNoteType = this.noteTypes[0];
        this.messageForm = this.formBuilder.group(
            {
                message: ['', [Validators.required, Validators.minLength(0)]],
                noteType: [this.selectedNoteType, [Validators.required]]
            });
        if (this.extraNote == undefined) {
            this.extraNote = {
                message: '',
                user: {email: ''}
            };
        }
    }

    addNote() {
        if (!this.messageForm.get('message').valid) {
            return false;
        }
        const payload: PostPayloadInterface = {
            id: this.connectEntityId,
            type: 'AddNote',
            attribute: {
                message: this.messageForm.get('message').value,
                type: this.selectedNoteType,
                entityId: this.connectEntityId
            }
        };
        this.noteRepository.saveNote(payload, this.connectEntity).subscribe(data => {

            this.notificationService.showSuccessWithoutTranslation('Comment is success');
            this.notes.unshift(data);
            //this.messageForm.get('message').reset("");
            this.onSelectedNoteTypeChange();
            this.saveCallback.emit(data);
        })
    }

    get messageF() {
        return this.messageForm.controls;
    }

    answer(note: any) {
        this.answerNote = note
    }

    answerForNote() {
        if (!this.messageForm.get('message').valid) {
            return false;
        }
        const payload: PostPayloadInterface = {
            id: this.connectEntityId,
            type: 'Answer',
            attribute: {message: this.messageForm.get('message').value, parentNote: this.answerNote.id}
        };
        this.answerNote.childNote = {
            message: this.messageForm.get('message').value,
            user: {email: 'sany@lali.hu'}
        }
        this.answerNote = null;
        // this.noteRepository.saveNote(payload, this.connectEntity).subscribe(data => {
        //
        //     this.notificationService.showSuccessWithoutTranslation('Comment is success');
        //     this.notes.unshift(data);
        // })
    }

    onSelectedNoteTypeChange() {
        let filteredNotes = this.notes.filter(note => note.type == this.selectedNoteType);
        if (this.selectedNoteType == Constants.NOTE_TYPE.SIMPLE_MESSAGE && filteredNotes.length > 0) {
            this.messageForm.get('message').setValue(filteredNotes[0].message);
        } else {
            this.messageForm.get('message').reset("");
        }
    }
}
